import {
 AfterViewInit,
 Component,
 EventEmitter,
 Input,
 OnChanges,
 OnInit,
 Output,
 SimpleChanges,
 ViewChild,
 afterNextRender,
 signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ISwiperConfigs } from '@core/models/domains/slider.model';
import { SwiperComponent } from 'swiper/angular';
import { HotelsCardComponent } from '../../../hotels-card/hotels-card.component';
import { SwiperOptions } from 'swiper';
import { fadeAnimation } from '../../../../home-page-wrapper.component';

@Component({
 selector: 'iho-renting-residences-view',
 templateUrl: './renting-residences-view.component.html',
 styleUrls: ['./renting-residences-view.component.scss'],
 animations: [fadeAnimation],
})
export class SliderRentingResidencesComponent implements AfterViewInit {
 @ViewChild('template', { static: true }) template: any;
 @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
 showArrowPrev = false;
 showArrowNext = true;
 resetSwiper = signal(false);

 _dataSource: any;
 selectedTabName: string = 'اجاره آپارتمان روزانه در تهران';
 @Input() set dataSource(value: any) {
  if (value) {
   this.resetSwiper.set(false);
   this._dataSource = value;
  }
 }
 _tabsTitles: any;
 @Input() set tabsTitles(value: any) {
  if (value) this._tabsTitles = value['Sections'][2]['Section']['Data']['FilterNavs'];
 }
 @Output() emitActiveTab = new EventEmitter<string>();
 sliderConfigs: SwiperOptions = {
  //slidesPerView: 5,
  spaceBetween: 15,
  grabCursor: true,
  //  spaceBetween: 20,
  breakpoints: {
   // when window width is >= 320px
   150: {
    slidesPerView: 'auto',
    spaceBetween: 20,
   },
   320: {
    slidesPerView: 'auto',
    spaceBetween: 20,
   },
   // when window width is >= 480px
   480: {
    slidesPerView: 'auto',
    spaceBetween: 30,
   },
   // when window width is >= 640px
   1200: {
    slidesPerView: 'auto',
    spaceBetween: 15,
    //  width:400,
   },
  },
 };

 constructor() {}

 ngAfterViewInit(): void {
  this.sliderConfigs = {
   //slidesPerView: 5,
   spaceBetween: 15,
   grabCursor: true,
   //  spaceBetween: 20,
   breakpoints: {
    // when window width is >= 320px
    150: {
     slidesPerView: 'auto',
     spaceBetween: 20,
    },
    320: {
     slidesPerView: 'auto',
     spaceBetween: 20,
    },
    // when window width is >= 480px
    480: {
     slidesPerView: 'auto',
     spaceBetween: 30,
    },
    // when window width is >= 640px
    1200: {
     slidesPerView: 'auto',
     spaceBetween: 15,
     //  width:400,
    },
   },
  };
 }
 nextSlide() {
  this.swiper?.swiperRef.slideNext(100);
 }

 previousSlide() {
  this.swiper?.swiperRef.slidePrev(100);
 }
 onSlideChange(ev: any) {
  if (ev[0].activeIndex === 0) {
   this.showArrowPrev = false;
   this.showArrowNext = true;
  } else if (ev[0].activeIndex != 0 && ev[0].isEnd == false) {
   this.showArrowPrev = true;
   this.showArrowNext = true;
  }
  if (ev[0].activeIndex != 0 && ev[0].isEnd == true) {
   this.showArrowPrev = true;
   this.showArrowNext = false;
  }
 }
 handledActiveTabs(itemActive: any) {
  this.resetSwiper.set(true);
  this._tabsTitles.forEach((item: any) => {
   if (this.selectedTabName == item.Name) {
    this.emitActiveTab.emit(itemActive.Url);
    item.isActive = true;
   } else {
    item.isActive = false;
   }
  });
 }
}
